import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import './aboutlayer.styles.scss';

const AboutLayer = () => {
  const xprops = useSelector(state => state);
  return(
    <React.Fragment>
    <div className="mainWorksWrapper">
      <div className="mainWorksHeader">
        <img className="mainWorksHeaderImg" src="/assets/images/middle-logo.png" alt={xprops.project.language.metas.title} />
        <h2 className="mainWorksHeaderTitle">{xprops.project.language.keywords.calismalar}</h2>
      </div>
      
      <div className="workshopWrapper">
        <div className="workshop">
          <Link to={xprops.project.language.routes.findExpert}><img className="workshop-image" src="/assets/images/soso-uye-olan-kadinlar.jpg" alt={xprops.project.language.keywords.kadinUzmanVeriTabani} /></Link>
          <div className="workshop-title-wrapper">
            <Link to={xprops.project.language.routes.findExpert} className="aboutTitleLinks"><h3 className="workshop-title">{xprops.project.language.keywords.kadinUzman}<span className="italic">{xprops.project.language.keywords.veriTabani}</span></h3></Link>
          </div>
          <div className="workshop-content-wrapper">
            <p className="workshop-content">
              {
                xprops.project.language.short === "TR" ? 
                <React.Fragment>
                Çeşitli alanlarda uzmanlaşmış kadınların profillerini oluşturabildikleri bir platform olan uzman veri tabanı, medya, sivil toplum ve özel sektör temsilcilerinin erişebileceği bir kaynak haline getirildi. Mayıs 2021'de faaliyete geçen bu uzman havuzunun şu anda 350 üyesi bulunmaktadır. Siz de uzmanlığınızı paylaşmak ve daha geniş bir kitleye ulaşmak için uzman havuzuna katılmak için <Link to="/signup">buraya</Link> tıklayabilirsiniz. 
                </React.Fragment>
                  :
                  <React.Fragment>
The expert database, a platform, where women specialists can create profiles, serves as a resource accessible to media, civil society, and private sector representatives. Launched in May 2021, the database has over 350 members. <br/><br/>You can join the expert pool from here to share your expertise and reach a broader audience.
                  </React.Fragment>
                  
              }

            
            </p>
          </div>
        </div>

        <div className="workshop">
          <Link to={xprops.project.language.routes.educations}><img className="workshop-image" src="/assets/images/egitimler.jpg" alt={xprops.project.language.keywords.medyaEgitimleri} /></Link>
          <div className="workshop-title-wrapper">
            <Link to={xprops.project.language.routes.educations} className='aboutTitleLinks'><h3 className="workshop-title">{xprops.project.language.keywords.medyaEgitimleri}</h3></Link>
          </div>
          <div className="workshop-content-wrapper">
            <p className="workshop-content">
            {
                xprops.project.language.short === "TR" ? 
                <React.Fragment>
                Alanında uzman kadınların medya ile ilişkilerini daha etkili ve verimli kurabilmeleri için medya eğitimleri düzenleniyor. Deneyimli medya uzmanları tarafından gönüllü kadın uzmanlar “medya nasıl çalışır, medyayı etkili ve verimli şekilde kullanmanın yolları” nelerdir konulu teorik ve pratik çalışma içeren eğitimler ile gerçekleştiriliyor. Mayıs 2021’den beri 138 kadın uzman eğitimlere katıldı.            
                </React.Fragment>
                  :
                  <React.Fragment>
                  Media training sessions are offered to help women experts establish more effective and productive relationships with the media. Conducted by experienced media professionals, these trainings include both theoretical and practical workshops on topics like how the media works, how to present oneself and effective media usage. Since May 2021, more than 180 women experts have participated.
                  </React.Fragment>
              }
            </p>
          </div>
        </div>

        <div className="workshop">
          <Link to={xprops.project.language.routes.mentoring}><img className="workshop-image" src="/assets/images/kadin-uzmanlar-icin-kocluk-calismasi.jpg" alt={xprops.project.language.keywords.mentorlukCalismalari} /></Link>
          <div className="workshop-title-wrapper">
            <Link to={xprops.project.language.routes.mentoring} className='aboutTitleLinks'><h3 className="workshop-title">{xprops.project.language.keywords.mentoring}<span className="italic">{xprops.project.language.keywords.calismalari}</span></h3></Link>
          </div>
          <div className="workshop-content-wrapper">
            <p className="workshop-content">
            {
                xprops.project.language.short === "TR" ? 
                <React.Fragment>
                    Kadınların iş hayatında kariyerlerini güçlendirmelerine ve karşılaştıkları zorlukları aşmalarına yardımcı olmayı amaçlayan koçluk çalışmaları gerçekleştiriliyor. 2022-2023 yıllarında, 10'un üzerinde kadın uzman mentorlük çalışmasından faydalandı. 
                </React.Fragment>
                  :
                  <React.Fragment>
                  Coaching programs are conducted one-on-one to help women strengthen their careers and overcome challenges in their professional lives. Between 2022-2024, 17 women experts benefited from mentorship programs.
                  </React.Fragment>
                  
              }

              
            </p>
          </div>
        </div>       
        <div className="workshop">
          <a href='https://www.sessizolmaz.org'><img className="workshop-image" src="/assets/images/roportaj.jpg" alt={xprops.project.language.keywords.sessizOlmazBlog} /></a>
          <div className="workshop-title-wrapper">
            <a href='https://www.sessizolmaz.org' className='aboutTitleLinks'><h3 className="workshop-title">{xprops.project.language.keywords.sessizOlmazBlog}</h3></a>
          </div>
          <div className="workshop-content-wrapper">
            <p className="workshop-content">
              {
                xprops.project.language.short === "TR" ? 
                <React.Fragment>
                    <a href="https://www.sessizolmaz.org"><b>https://www.sessizolmaz.org</b></a>
                    <br/><br/>                  
                    Sessiz Olmaz blogunda çeşitli alanlarda makaleler, röportajlar ve podcastler paylaşılıyor. Bloga uzmanlık alanınızdan bir yazı ile katkıda bulunmak isterseniz, lütfen bizimle iletişime geçin. 
                </React.Fragment>
                  :
                  <React.Fragment>
                    <a href="https://www.sessizolmaz.org"><b>https://www.sessizolmaz.org</b></a><br/><br/> The Sessiz Olmaz blog features articles, interviews, and podcasts on various topics. If you would like to contribute an article from your area of expertise, please contact us.
                  </React.Fragment>
                  
              }              
              
            </p>
          </div>
        </div>
        <div className="workshop">
          <Link to={xprops.project.language.routes.awarenessCampaigns}><img className="workshop-image" src="/assets/images/duyuru.jpg" alt={xprops.project.language.keywords.farkindalikCalismalari} /></Link>
          <div className="workshop-title-wrapper">
            <Link to={xprops.project.language.routes.awarenessCampaigns} className='aboutTitleLinks'><h3 className="workshop-title">{xprops.project.language.keywords.farkindalik}<span className="italic">{xprops.project.language.keywords.campaigns}</span></h3></Link>
          </div>
          <div className="workshop-content-wrapper">
            <p className="workshop-content">
            {
                xprops.project.language.short === "TR" ? 
                <React.Fragment>
                    Platformun aşağıdaki sosyal medya hesapları üzerinden kadınların medya ve kamusal alanda daha fazla görünür olmalarını teşvik eden içerikler paylaşılıyor: 
                    <br/>
                    <b>Twitter:</b> @sensizolmazorg <br/>
                    <b>Instagram:</b> sensizolmazorg <br/>
                    <b>LinkedIn:</b> Sensiz Olmaz Sessiz Olmaz <br/>
                    <b>Facebook:</b> Sensiz Olmaz Sessiz Olmaz <br/>
                    <b>Spotify:</b> Sensiz Olmaz Sessiz Olmaz Podcast <br/>
                </React.Fragment>
                  :
                  <React.Fragment>
                    Through its social media accounts, the platform shares content encouraging greater visibility of women in media and public spaces.
                    <span className='followTitle'>Follow {xprops.project.language.metas.title} on:</span>
                    <b>Twitter:</b> @sensizolmazorg <br/>
                    <b>Instagram:</b> sensizolmazorg <br/>
                    <b>LinkedIn:</b> Sensiz Olmaz Sessiz Olmaz <br/>
                    <b>Facebook:</b> Sensiz Olmaz Sessiz Olmaz <br/>
                    <b>Spotify:</b> Sensiz Olmaz Sessiz Olmaz Podcast <br/>
                  </React.Fragment>
                  
              }                   

            </p>
          </div>
        </div>                
        <div className="workshop">
          <Link to={xprops.project.language.routes.meetings}><img className="workshop-image" src="/assets/images/toplantilar.jpg" alt={xprops.project.language.keywords.toplantilar} /></Link>
          <div className="workshop-title-wrapper">
            <Link to={xprops.project.language.routes.meetings} className='aboutTitleLinks'><h3 className="workshop-title margin-bottom-0">{xprops.project.language.keywords.toplantilar}</h3></Link>
          </div>
          <div className={`workshop-content-wrapper ${xprops.project.language.short}`}>
            <p className="workshop-content">
            {
                xprops.project.language.short === "TR" ? 
                <React.Fragment>
                    Her yıl, platform çatısı altında kadın uzmanlar ve medya temsilcilerinin bir araya geldiği toplantılar ve çalıştaylar düzenlenmektedir. Bu etkinlikler, katılımcılara networking fırsatları sunmanın yanı sıra, karşılıklı talepleri ve beklentileri tartışma imkanı tanımaktadır. Aynı zamanda, kadın uzmanları medya dünyasıyla tanıştırma işlevini de görmektedir.
                </React.Fragment>
                  :
                  <React.Fragment>
                    Every year, the platform organizes meetings and workshops bringing together women experts and media representatives. These events not only provide networking opportunities but also facilitate discussions on mutual expectations and demands towards increasing visibility of women, also serving as an introduction of women experts to the media world.
                    <br/><br/>The platform also brings women experts together around specific themes, such as peace building, regional conflicts and other areas to support women networks both domestic and international. 
                  </React.Fragment>
              }                  
            </p>
          </div>
        </div>          
      </div>

    </div>

    </React.Fragment>
  );
}

export default AboutLayer;